<template>
  <AuthKit @token="successAuth"/>
</template>
<script setup>
import {useDialogStore} from "@/stores/dialogStore.js";
import {useUserStore} from '@/stores/userStore';
import {useCookieStore} from "~/stores/cookieStore.js";

const dialogStore = useDialogStore()
const userStore = useUserStore()
const cookieStore = useCookieStore();

const successAuth = async (t) => {
  //ТОЛЬКО ДЛЯ ЛОКЛЬНОЙ РАЗРАБОТКИ
  if(import.meta.dev && t) {
    cookieStore.updateToken(t.token)
    const refreshToken = useCookie('GATEWAY_REFRESH', { path: '/proxy/account-recovery-api.bpmn/auth/login/refresh/token' })
    refreshToken.value = t.refresh
  }

  await userStore.updateToken()
  //@ts-nocheck
  RocketChat(function() {
    this.hideWidget();
    const el = document.querySelector('.rocketchat-widget');
    if (el) {
      el.style.display = 'none';
    }
  });
  dialogStore.close()
}
</script>
<style scoped lang="sass">

</style>
